import { CoinChip } from '../ui/components';
import { state, isPremiumActive } from '../store';
import { api } from '../api/client';
import { t } from '../i18n';
import { sanitizeHtml } from '../utils/sanitize';

window.showLangPicker = () => {
  const currentLang = state.user?.lang || 'en';
  
  // Удалить существующий если есть
  document.getElementById('lang-picker-overlay')?.remove();
  
  const overlay = document.createElement('div');
  overlay.id = 'lang-picker-overlay';
  overlay.style.cssText = 'position:fixed;inset:0;z-index:1000;background:rgba(0,0,0,0.7);backdrop-filter:blur(8px);display:flex;align-items:center;justify-content:center;padding:24px;';
  
  overlay.innerHTML = `
    <div style="background:linear-gradient(135deg,#13112A,#1A1836);border:1px solid rgba(255,255,255,0.1);border-radius:24px;padding:24px;width:100%;max-width:300px;">
      <div style="font-family:Inter,sans-serif;font-size:20px;font-weight:800;color:#fff;text-align:center;margin-bottom:20px;">🌍 Language</div>
      ${[{code:'en',flag:'🇬🇧',label:'English'},{code:'ru',flag:'🇷🇺',label:'Русский'}].map(l => `
        <div data-action="set-lang" data-lang="${l.code}" style="
          display:flex;align-items:center;gap:14px;padding:16px;border-radius:16px;cursor:pointer;
          margin-bottom:10px;transition:all 0.15s;
          background:${currentLang === l.code ? 'rgba(255,45,107,0.15)' : 'rgba(255,255,255,0.05)'};
          border:1.5px solid ${currentLang === l.code ? 'rgba(255,45,107,0.5)' : 'rgba(255,255,255,0.08)'};
        ">
          <span style="font-size:28px;">${l.flag}</span>
          <span style="font-size:16px;font-weight:700;color:#fff;">${l.label}</span>
          ${currentLang === l.code ? '<span style="margin-left:auto;color:#FF2D6B;font-size:18px;">✓</span>' : ''}
        </div>
      `).join('')}
      <div data-action="close-lang-picker" style="text-align:center;color:#6B6890;font-size:14px;font-weight:600;cursor:pointer;padding:10px;">${t('cancel_btn')}</div>
    </div>
  `;
  
  overlay.addEventListener('click', e => { if(e.target === overlay) overlay.remove(); });
  document.body.appendChild(overlay);
};

window.setLang = async (lang: string) => {
  document.getElementById('lang-picker-overlay')?.remove();
  try {
    await api.setLang(lang);
    if (state.user) state.user.lang = lang;
    window.showToast(t('toast_lang_changed'), 'success');
    window.renderApp(); // перерисовать с новым языком
  } catch(e) {
    window.showToast(t('error_lang'), 'error');
  }
};

export function renderProfile(): string {
  return `
    <div class="absolute inset-0 overflow-y-auto overflow-x-hidden pb-[96px] z-10 scrollbar-none bg-void text-t-primary">
      <div class="flex flex-col items-center p-[28px_20px_20px] text-center">
        <div class="w-[90px] h-[90px] rounded-full bg-grad-primary flex items-center justify-center text-[40px] shadow-[0_0_32px_rgba(255,45,107,0.4)] mb-[12px]">😎</div>
        <div class="font-display text-[24px] font-extrabold">${sanitizeHtml(state.user?.first_name || 'Player')}</div>
        <div class="mt-[10px] flex items-center justify-center gap-[6px]">
          ${CoinChip({ amount: `${state.user?.coins ?? 0} coins`, onClick: "nav-premium" })}
          ${isPremiumActive() ? `<div class="flex items-center gap-[4px] bg-neon-gold/[0.15] border border-neon-gold/[0.3] rounded-pill py-[5px] px-[10px]">
            <span class="text-[13px]">👑</span>
            <span class="text-[11px] font-extrabold text-neon-gold">PRO</span>
          </div>` : ''}
        </div>

        ${isPremiumActive() ? `
          <div class="w-full mt-[16px]">
            <div class="bg-gradient-to-br from-[#FFD700]/[0.15] to-[#FF8C00]/[0.08] border border-[#FFD700]/[0.25] rounded-[18px] p-[14px_16px] flex items-center gap-[12px]">
              <span class="text-[24px]">👑</span>
              <div class="flex-1 text-left">
                <div class="text-[14px] font-extrabold text-neon-gold">${t('home_premium_active')}</div>
                <div class="text-[12px] text-t-secondary mt-[2px] font-semibold">
                  ${(() => {
                    const ea = state.user?.premium_expires_at;
                    if (!ea) return t('profile_premium_forever');
                    const num = Number(ea);
                    const d = isNaN(num) ? new Date(String(ea)) : new Date(num * 1000);
                    return isNaN(d.getTime()) ? t('profile_premium_forever') : t('profile_premium_until') + ' ' + d.toLocaleDateString();
                  })()}
                </div>
              </div>
            </div>
          </div>
        ` : `
          <div class="w-full mt-[16px]">
            <div class="bg-gradient-to-br from-[#FFD700]/[0.15] to-[#FF8C00]/[0.08] border border-[#FFD700]/[0.25] rounded-[18px] p-[14px_16px] flex items-center gap-[12px] cursor-pointer" data-action="nav" data-to="premium">
              <span class="text-[24px]">👑</span>
              <div class="flex-1 text-left">
                <div class="text-[14px] font-extrabold text-neon-gold">${t('profile_no_premium')}</div>
                <div class="text-[12px] text-t-secondary mt-[2px] font-semibold">${t('profile_no_premium_sub')}</div>
              </div>
              <div class="text-[14px] text-neon-gold font-extrabold">${t('profile_get')}</div>
            </div>
          </div>
        `}
      </div>

      <div class="text-[12px] font-extrabold tracking-[1.5px] uppercase text-t-muted mb-[12px] px-[20px]">${t('profile_settings')}</div>
      <div class="flex flex-col gap-[8px] px-[16px]">
        <div class="flex items-center gap-[14px] p-[15px_16px] bg-glass border border-b-glass rounded-[18px] cursor-pointer transition-colors active:bg-white/10" data-action="show-lang-picker">
          <div class="text-[22px]">🌍</div>
          <div class="flex-1 text-[15px] font-bold">${t('profile_language')}</div>
          <div class="flex items-center gap-[6px]">
            <span class="text-[13px] text-t-secondary font-bold">${state.user?.lang === 'ru' ? '🇷🇺 Русский' : '🇬🇧 English'}</span>
            <div class="text-[18px] text-t-muted">›</div>
          </div>
        </div>
        <div class="flex items-center gap-[14px] p-[15px_16px] bg-glass border border-b-glass rounded-[18px] cursor-pointer transition-colors active:bg-white/10" data-action="open-url" data-url="https://pandoragames.party/terms.html">
          <div class="text-[22px]">📄</div>
          <div class="flex-1 text-[15px] font-bold">${t('profile_terms')}</div>
          <div class="text-[18px] text-t-muted">›</div>
        </div>
        <div class="flex items-center gap-[14px] p-[15px_16px] bg-glass border border-b-glass rounded-[18px] cursor-pointer transition-colors active:bg-white/10" data-action="open-url" data-url="https://pandoragames.party/privacy.html">
          <div class="text-[22px]">🔒</div>
          <div class="flex-1 text-[15px] font-bold">${t('profile_privacy')}</div>
          <div class="text-[18px] text-t-muted">›</div>
        </div>
        <div class="flex items-center gap-[14px] p-[15px_16px] bg-glass border border-b-glass rounded-[18px] cursor-pointer transition-colors active:bg-white/10" data-action="open-url" data-url="mailto:pandoragames@proton.me?subject=Party%20Games%20Feedback">
          <div class="text-[22px]">💬</div>
          <div class="flex-1 text-[15px] font-bold">${t('profile_support')}</div>
          <div class="text-[18px] text-t-muted">›</div>
        </div>
      </div>

      <div class="text-center p-[24px] text-[12px] text-t-muted font-semibold">
        ${t('profile_version')}
      </div>
    </div>
  `;
}
